import queryString from 'query-string'

export const paths = {
    home: '/',
    login: '/auth/login',
    forgot: '/auth/forgot',
    customersQualifiedProspects: '/customers/qualified-prospects',
    cutomersActive: '/cutomers/active',
    customersCoollead: '/customers/coollead',
    customersTrial: '/customers/trial',
    customersStop: '/customers/stop',
    customerCreate: '/customers/new',
    customerDetail: '/customers/:id',
    services: '/services',
    invoices: '/invoices',
    employeesManage: '/employees',
    departmentDetail: '/employees/departments/:id',
    dayOffsManage: '/dayoffs',
    businessesManage: '/businesses',
    workdayList: '/account/workdays',
    workdayManage: '/workdays/manage',
    workdayHoliday: '/workdays/holiday',
    workdayHolidayDetail: '/workdays/holiday/:id',
    workdayHolidayCreate: '/workdays/holiday/new',
    customerMkt: '/contacts',
    customerNewlMkt: '/contacts/new',
    hrContact: '/contacts/humanresources',
    customerSpam: '/customer_spams',
    employeeCreate: '/employees/new',
    businessAccountList: '/account/businesses',
    businessAccountDetail: '/account/businesses/:id',
    businessAccountCreate: '/account/businesses/new',
    employeeUpdate: '/employees/:id/update',
    employeeUpdateAdvanced: '/employees/:id/update-advanced',
    dayOffHRMList: '/dayoffs',
    dayOffAccountList: '/account/dayoffs',
    dayOffCreatePage: '/account/dayoffs/new',
    dayOffDetail: '/dayoffs/:id',
    dayOffEdit: '/account/dayoffs/:id/edit',
    // Oncall Management
    oncall: '/oncall',
    oncallSchedules: '/oncall/schedules',
    oncallScheduleCreate: '/oncall/schedules/new',
    oncallScheduleDetail: '/oncall/schedules/:id',
    oncallScheduleEdit: '/oncall/schedules/:id/edit',
    oncallAssignments: '/oncall/assignments',
    oncallAssignmentDetail: '/oncall/assignments/:id',
    oncallSwaps: '/oncall/swaps',
    oncallSwapCreate: '/oncall/swaps/new',
    oncallSwapDetail: '/oncall/swaps/:id',
    oncallCompensations: '/oncall/compensations',
    oncallCompensationReport: '/oncall/compensations/report',
    oncallCompensationDetail: '/oncall/compensations/:id',
    oncallLogs: '/oncall/logs',
    vcardList: '/account/vcards',
    vcardCreatePage: '/account/vcards/new',
    vcardEditPage: '/account/vcards/:id/edit',
    createContract: '/contracts/new',
    customersList: '/customers',
    ticket: '/tickets',
    ticketDetail: '/tickets/:id',
    ticketCreate: '/tickets/new',
    ticketEdit: '/tickets/:id/edit',
    // Capacities & Resources (was Warehouse)
    warehouse: '/warehouse',
    warehouseCloud: '/warehouse/cloud',
    warehouseCloudProvider: '/warehouse/cloud/providers/:providerType',
    warehouseCloudZone: '/warehouse/cloud/zones/:zoneId',
    warehouseInventory: '/warehouse/inventory',
    warehouseItems: '/warehouse/items',
    warehouseEquipment: '/warehouse/equipment',
    warehouseComponents: '/warehouse/components',
    warehouseLocations: '/warehouse/locations',
    warehouseRacks: '/warehouse/racks',
    warehouseSuppliers: '/warehouse/suppliers',
    warehouseSupplierCreate: '/warehouse/suppliers/new',
    warehouseModels: '/warehouse/models',
    warehouseModelCreate: '/warehouse/models/new',
    warehouseProcesses: '/warehouse/processes',
    warehouseProcessCreate: '/warehouse/processes/new',
    contractDetail: '/contracts/:id',
    serviceDetail: '/services/:id',
    serviceSLAConfig: '/services/:id/sla',
    serviceSLADashboard: '/services/sla-dashboard',
    serviceCreateAddons: '/services/:id/addons/new',
    customerContractList: '/contracts',
    partnerContractList: '/contracts/partners',
    sampleContractList: '/contracts/samples',
    customerContractDetail: '/contracts/:id',
    drive: '/drive',
    documentList: '/documents',
    documentShare: '/documents/share',
    documentCreate: '/documents/new',
    documentUpdate: '/documents/:id/edit',
    documentApproved: '/documents/approved',
    subContractDetail: '/contracts/:contractID/subcontracts/:subcontractID',
    invoiceDetail: '/invoices/:id',
    reportCustomer: '/reports/customers',
    reportService: '/reports/services',
    reportServiceMonthly: '/reports/services/monthly',
    reportIncome: '/reports/incomes',
    reportRevenue: '/reports/revenues',
    reportBusinessTargets: '/reports/business-targets',
    reportBusinessPerformance: '/reports/business-performance',
    reportFinance: '/reports/financials',
    reportTargetAnalytics: '/reports/targets-analytics',
    customerScanCards: '/customers/scan-cards',
    customerCreatePOC: '/customers/:id/poc',
    customerContractOverview: '/contracts/overview/:type',
    jobEdit: '/jobs/:jobID',
    jobCreate: '/jobs/new',
    jobList: '/jobs',
    jobCategoryList: '/job-categories',
    jobCategoryCreate: '/job-categories/new',
    talentPoolManager: '/resume',
    talentPoolCreate: '/resume/new',
    talentPoolDetail: '/resume/:id',
    kpiManage: '/kpi-manage',
    kpiCreate: '/kpi-manage/create',
    releaseNotes: '/release-notes',
    // Developer section
    apiUsageTemplates: '/developer/api-usage-templates',
    apiUsageTemplateCreate: '/developer/api-usage-templates/new',
    apiUsageTemplateEdit: '/developer/api-usage-templates/:id/edit',
    dataAccess: '/settings/data-access',
    dataAccessCreate: '/settings/data-access/new',
    dataAccessEdit: '/settings/data-access/:id/edit',
    authorization: '/settings/authorization',
    reportAnalytics: '/reports/analytics',
    reportWAF: '/technical/report',
    partnerContractDetail: '/contracts/partners/:id',
    supplierDetail: '/contracts/partners/suppliers/:id',
    account: '/account',
    accountRegulations: '/account/regulations',
    accountMyIncomes: '/account/my-incomes',
    accountMyRatings: '/account/my-ratings',
    accountCustomerEvents: '/account/customer-events',
    // Contract Negotiation
    contractNegotiation: '/contracts/negotiations',
    contractNegotiationDetail: '/contracts/negotiations/:id',
    // Requirements
    requirements: '/requirements',
    serviceConfigEdit: '/services/:id/config',
    employeeUpdateIdentity: '/employees/:id/identity',

    // settings
    settings: '/settings',
    serviceTemplates: '/settings/service-templates',
    regulations: '/settings/regulations',
    slaTemplates: '/settings/sla-templates',
    slaTemplateCreate: '/settings/sla-templates/create',
    slaTemplateEdit: '/settings/sla-templates/:id/edit',
    productServiceManagement: '/settings/product-services',
    // Tenders
    tenders: '/tenders',
    tenderDetail: '/tenders/:tenderId',
    tenderBidResult: '/tenders/:tenderID/bid-result',
    // Surveys
    surveys: '/surveys',
    surveyCreate: '/surveys/new',
    surveyDetail: '/surveys/:surveyId',
    surveyRecordCreate: '/surveys/records/new',
    surveyRecordDetail: '/surveys/records/:surveyRecordId',
    surveyAnalytics: '/surveys/:surveyId/analytics',
    surveyEdit: '/surveys/:surveyId/edit',
    surveyAnalyticsV2: '/surveys?tab=analytics-v2',

    // Mailer Campaign
    mailerCampaign: '/mailers/campaigns',
    mailerCampaignDetail: '/mailers/campaigns/:id',
    mailerCampaignCreate: '/mailers/campaigns/new',
    mailerCampaignEdit: '/mailers/campaigns/:id/edit',
    mailerTemplateCreate: '/mailers/campaigns/templates/new',
    mailerTemplateDetail: '/mailers/campaigns/templates/:id',
    mailerTemplateEdit: '/mailers/campaigns/templates/:id/edit',

    // Livechat
    livechat: '/livechat',

    // Resellers
    resellersList: '/resellers',
    resellerCreate: '/resellers/new',
    resellerDetail: '/resellers/:id',

    // Affiliates
    affiliatesList: '/affiliates',
    affiliateCreate: '/affiliates/new',
    affiliateDetail: '/affiliates/:id',
    affiliateCommissionPolicies: '/affiliates/commission-policies',
    employeeAffiliatesList: '/affiliates/employees',

    // Promos
    promosList: '/promos',
    promoCreate: '/promos/new',
    promoDetail: '/promos/:id',

    // Technical
    technical: '/technical',

    // Threshold (Healthcheck Monitoring)
    threshold: '/technical/threshold',
    thresholdCreate: '/technical/threshold/new',
    thresholdDetail: '/technical/threshold/:id',
    thresholdEdit: '/technical/threshold/:id/edit',
    thresholdMonitors: '/technical/threshold/monitors',
    thresholdMonitorCreate: '/technical/threshold/monitors/new',
    thresholdMonitorDetail: '/technical/threshold/monitors/:id',
    thresholdMonitorEdit: '/technical/threshold/monitors/:id/edit',
    thresholdAlarms: '/technical/threshold/alarms',
    thresholdAlarmCreate: '/technical/threshold/alarms/new',
    thresholdAlarmDetail: '/technical/threshold/alarms/:id',
    thresholdAlarmEdit: '/technical/threshold/alarms/:id/edit',
    thresholdChannels: '/technical/threshold/channels',
    thresholdChannelCreate: '/technical/threshold/channels/new',
    thresholdChannelDetail: '/technical/threshold/channels/:id',
    thresholdChannelEdit: '/technical/threshold/channels/:id/edit',
    thresholdAlarmEvents: '/technical/threshold/events',

    // Watchpoint
    watchpoint: '/technical/watchpoint',
    watchpointList: '/technical/watchpoint/watchpoints',
    watchpointCreate: '/technical/watchpoint/watchpoints/new',
    watchpointDetail: '/technical/watchpoint/watchpoints/:id',
    watchpointEdit: '/technical/watchpoint/watchpoints/:id/edit',
    watchpointAlarms: '/technical/watchpoint/alarms',
    watchpointEvents: '/technical/watchpoint/events',
    watchpointChannels: '/technical/watchpoint/channels',
    watchpointChannelDetail: '/technical/watchpoint/channels/:id',
    watchpointPlaybooks: '/technical/watchpoint/playbooks',
    watchpointPlaybookCreate: '/technical/watchpoint/playbooks/new',
    watchpointPlaybookDetail: '/technical/watchpoint/playbooks/:id',
    watchpointPlaybookEdit: '/technical/watchpoint/playbooks/:id/edit',

    // Assets
    assetsList: '/assets',
    assetCreate: '/assets/new',
    assetDetail: '/assets/:slug',
    assetEdit: '/assets/:id/edit',

    // Tools
    toolsConvertWebp: '/tools/convert-webp',
    toolsWafFreeReport: '/tools/waf-free-report',
} as const

// Type to extract dynamic params from the path
type PathParams<Path extends string> =
    Path extends `${string}:${infer Param}/${infer Rest}`
        ? { [K in Param | keyof PathParams<`/${Rest}`>]: string }
        : Path extends `${string}:${infer Param}`
          ? { [K in Param]: string }
          : {}

// Type mapping for all paths
type Paths = typeof paths
export type RouteParams<T extends keyof Paths> = PathParams<Paths[T]>

// Modified generatePath function
export const generatePathDatacentral = <T extends keyof Paths>(
    path: Paths[T],
    params: RouteParams<T>,
    query?: Record<string, string | number | (string | number)[] | undefined>
): string => {
    let newPath = path as string

    // Replace các dynamic params trong path
    for (const key in params) {
        if (Object.prototype.hasOwnProperty.call(params, key)) {
            newPath = newPath.replace(`:${key}`, (params as any)[key])
        }
    }

    // Build query string nếu có
    if (query && Object.keys(query).length > 0) {
        const searchParams = new URLSearchParams()

        for (const [key, value] of Object.entries(query)) {
            if (value === undefined) continue

            if (Array.isArray(value)) {
                // Nếu là array, append nhiều lần (filters=a&filters=b)
                value.forEach((v) => searchParams.append(key, String(v)))
            } else {
                searchParams.append(key, String(value))
            }
        }

        newPath += `?${searchParams.toString()}`
    }

    return newPath
}

export const reactQueryKeys = {
    events: {
        create: () => ['events', 'create'],
        list: (filters?: Record<string, any>) => ['events', 'list', filters],
        detail: (id: string | number) => ['events', 'detail', id],
        update: (id: string | number) => ['events', 'update', id],
        delete: (id: string | number) => ['events', 'delete', id],
        roomAvailable: (date?: string) => ['events', 'room-available', date],
        summary: (date?: string) => ['events', 'summary', date],
        popular: (date?: string) => ['events', 'popular', date],
    },
    customers: {
        pattern: 'customers',
        create: () => ['customers', 'create'],
        list: (filters?: Record<string, any>) => ['customers', 'list', filters],
        detail: (id: string | number) => ['customers', 'detail', id],
        update: (id: string | number) => ['customers', 'update', id],
        delete: (id: string | number) => ['customers', 'delete', id],
        contacts: (id: string | number) => ['customers', 'contacts', id],
        credits: (id: string | number) => ['customers', 'credits', id],
        invoices: (id: string | number) => ['customers', 'invoices', id],
        mailers: (id: string | number) => ['customers', 'mailers', id],
        poc: (id: string | number) => ['customers', 'poc', id],
        statistical: () => ['customers', 'statistical'],
        serviceOptions: (id: string | number) => [
            'customers',
            'service-options',
            id,
        ],
        contracts: {
            pattern: 'contracts',
            list: (id: string | number) => ['contracts', 'list', id]?.join('.'),
        },
        negotiations: {
            pattern: 'negotiations',
            list: (id: string | number) => ['negotiations', 'list', id],
        },
    },
    contracts: {
        create: () => ['contracts', 'create'],
        list: (filters?: Record<string, any>) => ['contracts', 'list', filters],
        detail: (id: string | number) => ['contracts', 'detail', id],
        update: (id: string | number) => ['contracts', 'update', id],
        delete: (id: string | number) => ['contracts', 'delete', id],
        overview: (type?: string) => ['contracts', 'overview', type],
        statistical: (filters?: string) => [
            'contracts',
            'statistical',
            filters,
        ],
        processes: (id: string | number) => ['contracts', 'processes', id],
        subcontracts: (id: string | number) => [
            'contracts',
            'subcontracts',
            id,
        ],
    },
    services: {
        pattern: 'services',
        create: () => ['services', 'create'],
        list: (filters?: Record<string, any>) => ['services', 'list', filters],
        detail: (id: string | number) => ['services', 'detail', id],
        update: (id: string | number) => ['services', 'update', id],
        delete: (id: string | number) => ['services', 'delete', id],
        statistical: () => ['services', 'statistical'],
        addons: (id: string | number) => ['services', 'addons', id],
        statement: (id: string | number) => ['services', 'statement', id],
        monitoring: (id: string | number) => ['services', 'monitoring', id],
        apiUsage: (id: string | number) => ['services', 'api-usage', id],
        technical: (id: string | number) => ['services', 'technical', id],
        contracts: (id: string | number) => ['services', 'contracts', id],
        notifications: (id: string | number) => [
            'services',
            'notifications',
            id,
        ],
        analytics: {
            monitoring: (filters?: Record<string, any>) => [
                'services',
                'analytics',
                'monitoring',
                queryString.stringify(filters || {}),
            ],
        },
        summary: (filters?: Record<string, any>) => [
            'services',
            'summary',
            queryString.stringify(filters || {}),
        ],
        configoptions: (id: string | number) => [
            'services',
            'configoptions',
            id,
        ],
        alerts: (id: string | number) => ['services', 'alerts', id],
    },
    invoices: {
        pattern: 'invoices',
        payment: (id: string | number) => ['invoices', 'payment', id],
        create: () => ['invoices', 'create'],
        list: (filters?: Record<string, any>) => [
            'invoices',
            'list',
            queryString.stringify(filters || {}),
        ],
        detail: (id: string | number) => ['invoices', 'detail', id],
        update: (id: string | number) => ['invoices', 'update', id],
        delete: (id: string | number) => ['invoices', 'delete', id],
        statistical: (filters?: Record<string, any>) => [
            'invoices',
            'statistical',
            queryString.stringify(filters || {}),
        ],
        preview: (id: string | number) => ['invoices', 'preview', id],
    },
    employees: {
        create: () => ['employees', 'create'],
        list: (filters?: Record<string, any>) => ['employees', 'list', filters],
        detail: (id: string | number) => ['employees', 'detail', id],
        update: (id: string | number) => ['employees', 'update', id],
        delete: (id: string | number) => ['employees', 'delete', id],
        confirmation: (id: string | number) => [
            'employees',
            'confirmation',
            id,
        ],
        departments: (
            departmentID: number,
            q?: string,
            page?: number,
            page_size?: number
        ) => ['employees', 'departments', departmentID, q, page, page_size],
    },
    departments: {
        list: () => ['departments', 'list'],
        detail: (id: string | number) => ['departments', 'detail', id],
    },
    positions: {
        list: () => ['positions', 'list'],
        detail: (id: string | number) => ['positions', 'detail', id],
    },
    dayoffs: {
        create: () => ['dayoffs', 'create'],
        list: (filters?: Record<string, any>) => ['dayoffs', 'list', filters],
        detail: (id: string | number) => ['dayoffs', 'detail', id],
        update: (id: string | number) => ['dayoffs', 'update', id],
        delete: (id: string | number) => ['dayoffs', 'delete', id],
        statistical: () => ['dayoffs', 'statistical'],
    },
    businesses: {
        create: () => ['businesses', 'create'],
        list: (filters?: Record<string, any>) => [
            'businesses',
            'list',
            filters,
        ],
        detail: (id: string | number) => ['businesses', 'detail', id],
        update: (id: string | number) => ['businesses', 'update', id],
        delete: (id: string | number) => ['businesses', 'delete', id],
        statistical: () => ['businesses', 'statistical'],
    },
    tickets: {
        create: () => ['tickets', 'create'],
        list: (filters?: Record<string, any>) => ['tickets', 'list', filters],
        detail: (id: string | number) => ['tickets', 'detail', id],
        update: (id: string | number) => ['tickets', 'update', id],
        delete: (id: string | number) => ['tickets', 'delete', id],
        attachments: (id: string | number) => ['tickets', 'attachments', id],
        processing: (id: string | number) => ['tickets', 'processing', id],
    },
    documents: {
        create: () => ['documents', 'create'],
        list: (filters?: Record<string, any>) => ['documents', 'list', filters],
        detail: (id: string | number) => ['documents', 'detail', id],
        update: (id: string | number) => ['documents', 'update', id],
        delete: (id: string | number) => ['documents', 'delete', id],
    },
    drive: {
        root: () => ['drive', 'root'],
        myDrive: () => ['drive', 'my-drive'],
        starred: () => ['drive', 'starred'],
        recent: () => ['drive', 'recent'],
        sharedWithMe: () => ['drive', 'shared-with-me'],
        folder: (id: string | number) => ['drive', 'folder', id],
        file: (id: string | number) => ['drive', 'file', id],
    },
    workdays: {
        list: (filters?: Record<string, any>) => ['workdays', 'list', filters],
        detail: (id: string | number) => ['workdays', 'detail', id],
    },
    holidays: {
        create: () => ['holidays', 'create'],
        list: (filters?: Record<string, any>) => ['holidays', 'list', filters],
        detail: (id: string | number) => ['holidays', 'detail', id],
        update: (id: string | number) => ['holidays', 'update', id],
        delete: (id: string | number) => ['holidays', 'delete', id],
    },
    marketing: {
        list: (filters?: Record<string, any>) => ['marketing', 'list', filters],
        detail: (id: string | number) => ['marketing', 'detail', id],
        statistical: () => ['marketing', 'statistical'],
        revenue: () => ['marketing', 'revenue'],
        explanation: () => ['marketing', 'explanation'],
        conversation: (id: string | number) => [
            'marketing',
            'conversation',
            id,
        ],
    },
    jobs: {
        create: () => ['jobs', 'create'],
        list: (filters?: Record<string, any>) => ['jobs', 'list', filters],
        detail: (id: string | number) => ['jobs', 'detail', id],
        update: (id: string | number) => ['jobs', 'update', id],
        delete: (id: string | number) => ['jobs', 'delete', id],
    },
    jobCategories: {
        create: () => ['job-categories', 'create'],
        list: (filters?: Record<string, any>) => [
            'job-categories',
            'list',
            filters,
        ],
        detail: (id: string | number) => ['job-categories', 'detail', id],
        update: (id: string | number) => ['job-categories', 'update', id],
        delete: (id: string | number) => ['job-categories', 'delete', id],
    },
    resume: {
        create: () => ['resume', 'create'],
        list: (filters?: Record<string, any>) => ['resume', 'list', filters],
        detail: (id: string | number) => ['resume', 'detail', id],
        update: (id: string | number) => ['resume', 'update', id],
        delete: (id: string | number) => ['resume', 'delete', id],
    },
    kpi: {
        create: () => ['kpi', 'create'],
        list: (filters?: Record<string, any>) => ['kpi', 'list', filters],
        detail: (id: string | number) => ['kpi', 'detail', id],
        update: (id: string | number) => ['kpi', 'update', id],
        delete: (id: string | number) => ['kpi', 'delete', id],
    },
    vcards: {
        create: () => ['vcards', 'create'],
        list: (filters?: Record<string, any>) => ['vcards', 'list', filters],
        detail: (id: string | number) => ['vcards', 'detail', id],
        update: (id: string | number) => ['vcards', 'update', id],
        delete: (id: string | number) => ['vcards', 'delete', id],
    },
    reports: {
        pattern: 'reports',
        customers: () => ['reports', 'customers'],
        services: () => ['reports', 'services'],
        incomes: (filters?: Record<string, any>) => [
            'reports',
            'incomes',
            filters,
        ],
        revenues: () => ['reports', 'revenues'],
        financials: () => ['reports', 'financials'],
        customerStatistical: () => ['reports', 'customer-statistical'],
        customerServices: () => ['reports', 'customer-services'],
        customerOverTime: () => ['reports', 'customer-over-time'],
        customerIndustry: () => ['reports', 'customer-industry'],
    },
    surveys: {
        pattern: 'surveys',
        create: () => ['surveys', 'create'],
        list: (filters?: Record<string, any>) => [
            'surveys',
            'list',
            queryString.stringify(filters || {}),
        ],
        detail: (id: string | number) => ['surveys', 'detail', id],
        update: (id: string | number) => ['surveys', 'update', id],
        status: (id: string | number) => ['surveys', 'status', id],
        analytics: (id: string | number) => ['surveys', 'analytics', id],
        export: (id: string | number) => ['surveys', 'export', id],
    },
    authorization: {
        resources: {
            create: () => ['authorization', 'resources', 'create'],
            list: (filters?: Record<string, any>) => [
                'authorization',
                'resources',
                'list',
                filters,
            ],
            detail: (id: string | number) => [
                'authorization',
                'resources',
                'detail',
                id,
            ],
            update: (id: string | number) => [
                'authorization',
                'resources',
                'update',
                id,
            ],
            delete: (id: string | number) => [
                'authorization',
                'resources',
                'delete',
                id,
            ],
        },
        scopes: {
            create: () => ['authorization', 'scopes', 'create'],
            list: (filters?: Record<string, any>) => [
                'authorization',
                'scopes',
                'list',
                filters,
            ],
            detail: (id: string | number) => [
                'authorization',
                'scopes',
                'detail',
                id,
            ],
            update: (id: string | number) => [
                'authorization',
                'scopes',
                'update',
                id,
            ],
            delete: (id: string | number) => [
                'authorization',
                'scopes',
                'delete',
                id,
            ],
        },
        permissions: {
            create: () => ['authorization', 'permissions', 'create'],
            list: (filters?: Record<string, any>) => [
                'authorization',
                'permissions',
                'list',
                filters,
            ],
            detail: (id: string | number) => [
                'authorization',
                'permissions',
                'detail',
                id,
            ],
            update: (id: string | number) => [
                'authorization',
                'permissions',
                'update',
                id,
            ],
            delete: (id: string | number) => [
                'authorization',
                'permissions',
                'delete',
                id,
            ],
        },
        policies: {
            create: () => ['authorization', 'policies', 'create'],
            list: (filters?: Record<string, any>) => [
                'authorization',
                'policies',
                'list',
                filters,
            ],
            detail: (id: string | number) => [
                'authorization',
                'policies',
                'detail',
                id,
            ],
            update: (id: string | number) => [
                'authorization',
                'policies',
                'update',
                id,
            ],
            delete: (id: string | number) => [
                'authorization',
                'policies',
                'delete',
                id,
            ],
        },
        keycloak: {
            resources: () => ['authorization', 'keycloak', 'resources'],
        },
    },
    dataAccessAssignments: {
        create: () => ['data-access-assignments', 'create'],
        list: (filters?: Record<string, any>) => [
            'data-access-assignments',
            'list',
            filters,
        ],
        detail: (id: string | number) => [
            'data-access-assignments',
            'detail',
            id,
        ],
        update: (id: string | number) => [
            'data-access-assignments',
            'update',
            id,
        ],
        delete: (id: string | number) => [
            'data-access-assignments',
            'delete',
            id,
        ],
    },
    dashboard: {
        events: () => ['dashboard', 'events'],
        business: () => ['dashboard', 'business'],
        tasks: () => ['dashboard', 'tasks'],
        notifications: () => ['dashboard', 'notifications'],
        revenue: () => ['dashboard', 'revenue'],
    },
    search: {
        global: (query?: string) => ['search', 'global', query],
    },
    assistant: {
        bot: () => ['assistant', 'bot'],
    },
    productGroups: {
        list: () => ['product-groups', 'list'],
    },
    assets: {
        pattern: 'assets',
        create: () => ['assets', 'create'],
        list: (filters?: Record<string, any>) => ['assets', 'list', filters],
        detail: (id: string | number) => ['assets', 'detail', id],
        update: (id: string | number) => ['assets', 'update', id],
        delete: (id: string | number) => ['assets', 'delete', id],
        assign: (id: string | number) => ['assets', 'assign', id],
        transfer: (id: string | number) => ['assets', 'transfer', id],
        maintenance: (id: string | number) => ['assets', 'maintenance', id],
        history: (id: string | number) => ['assets', 'history', id],
        statistical: () => ['assets', 'statistical'],
    },
}
